import Swal from 'sweetalert2';
import jQuery from 'jquery';
import 'jquery-mask-plugin';
import 'datatables.net-dt';
import 'select2';
import 'materialize-css';
import 'jquery-maskmoney/dist/jquery.maskMoney';
import lottie from 'lottie-web';
import moment from 'moment';
window.moment = moment;
import 'jquery-validation';
const d3Selection = require('d3-selection');
window.d3Selection = d3Selection;
import bar from 'britecharts/src/charts/bar';
import line from 'britecharts/src/charts/line';
window.line = line;
import tooltip from 'britecharts/src/charts/tooltip';
window.tooltip = tooltip;
import colors from 'britecharts/src/charts/helpers/color';
window.colors = colors;
window.lottie = lottie;
import Sortable from 'sortablejs/modular/sortable.complete.esm.js';
window.Sortable = Sortable;
import Dropzone from 'dropzone';
window.Dropzone = Dropzone;
Dropzone.autoDiscover = false;
Dropzone.createImageThumbnails = false;
Dropzone.previewsContainer = false;
global.$ = global.jQuery = jQuery;
window.Swal = Swal;
import 'jquery-locationpicker';
import ApexCharts from 'apexcharts';
window.ApexCharts = ApexCharts;



